import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Hero extends Vue {
  @Prop({ default: '300px' })
  private minHeight!: string
}
